<div class="form-container service-form ms-large-t" #formContainer>
  <!-- Initial form state -->
  <form
    *ngIf="reactiveForm && (formStatus === FormStatus.INITIAL || formStatus === FormStatus.ERROR)"
    [formGroup]="reactiveForm"
    [finFormErrorFocus]="reactiveForm"
    (ngSubmit)="onSubmit()"
  >
    <!-- Error notification -->
    <fcom-notification
      *ngIf="formStatus === FormStatus.ERROR"
      class="mr-medium-b"
      [layout]="NotificationLayout.BLOCK"
      [theme]="NotificationTheme.ALERT"
    >
      {{ 'SERVICE_FORMS.NTServiceForms.error.title' | finLocalization }}
    </fcom-notification>
    <p class="font-body-1 mr-medium-b nordic-blue-900-text">
      {{ 'SERVICE_FORMS.NTServiceForms.mandatoryFields' | finLocalization }}
    </p>
    <div class="flex flex--row flex--wrap form-subgroup">
      <fcom-text-input
        [parentForm]="reactiveForm"
        [controlName]="'firstName'"
        [translationPrefix]="'SERVICE_FORMS.NTServiceForms.fields.firstName'"
      ></fcom-text-input>
      <fcom-text-input
        [parentForm]="reactiveForm"
        [controlName]="'lastName'"
        [translationPrefix]="'SERVICE_FORMS.NTServiceForms.fields.lastName'"
      ></fcom-text-input>
      <fcom-text-input
        [parentForm]="reactiveForm"
        [controlName]="'phoneNumber'"
        [placeHolder]="'SERVICE_FORMS.NTServiceForms.fields.phoneNumber.placeholder'"
        [translationPrefix]="'SERVICE_FORMS.NTServiceForms.fields.phoneNumber'"
      ></fcom-text-input>
      <fcom-text-input
        [parentForm]="reactiveForm"
        [controlName]="'email'"
        [translationPrefix]="'SERVICE_FORMS.NTServiceForms.fields.email'"
      ></fcom-text-input>
      <fcom-text-input
        [parentForm]="reactiveForm"
        [controlName]="'cardNumber'"
        [placeHolder]="'SERVICE_FORMS.NTServiceForms.fields.cardNumber.placeholder'"
        [translationPrefix]="'SERVICE_FORMS.NTServiceForms.fields.cardNumber'"
      ></fcom-text-input>
    </div>
    <div class="flex flex--row flex--wrap form-subgroup">
      <fin-datepicker
        [parentForm]="reactiveForm"
        [controlName]="'flightDate'"
        [placeHolder]="'SERVICE_FORMS.NTServiceForms.fields.flightDate.placeholder'"
        [minDate]="minDate"
        [maxDate]="maxDate"
        [translationPrefix]="'SERVICE_FORMS.NTServiceForms.fields.flightDate'"
        [theme]="datepickerThemes.WEB_2"
      ></fin-datepicker>
      <fcom-text-input
        [parentForm]="reactiveForm"
        [controlName]="'flightNumber'"
        [translationPrefix]="'SERVICE_FORMS.NTServiceForms.fields.flightNumberOfFirstFlight'"
        [placeHolder]="'SERVICE_FORMS.NTServiceForms.fields.flightNumberOfFirstFlight.placeholder'"
      ></fcom-text-input>
      <fin-locations-autocomplete
        [parentForm]="reactiveForm"
        [controlName]="'origin'"
        [translationPrefix]="'SERVICE_FORMS.NTServiceForms.fields.origin'"
        [inputType]="'text'"
        [options$]="departureLocations$"
        [loading$]="departureLoading$"
        [theme]="autocompleteThemes.WEB_2"
      ></fin-locations-autocomplete>
      <fin-locations-autocomplete
        [parentForm]="reactiveForm"
        [controlName]="'destination'"
        [translationPrefix]="'SERVICE_FORMS.NTServiceForms.fields.destination'"
        [inputType]="'text'"
        [options$]="destinationLocations$"
        [loading$]="destinationLoading$"
        [theme]="autocompleteThemes.WEB_2"
      ></fin-locations-autocomplete>
    </div>
    <div class="flex flex--row flex--wrap form-subgroup">
      <fcom-text-input
        [parentForm]="reactiveForm"
        [controlName]="'reservationNumber'"
        [placeHolder]="'SERVICE_FORMS.NTServiceForms.fields.reservationNumber.placeholder'"
        [translationPrefix]="'SERVICE_FORMS.NTServiceForms.fields.reservationNumber'"
      ></fcom-text-input>
    </div>
    <div class="flex flex--row flex--wrap form-subgroup">
      <fcom-radio-item-group
        class="ms-xlarge-b"
        [options]="specialAttentionReasonOptions"
        [parentForm]="reactiveForm"
        [controlName]="'reasonForSpecialAttention'"
        [isSensitive]="true"
        [isRequired]="true"
        [translationPrefix]="'SERVICE_FORMS.NTServiceForms.fields.reasonForSpecialAttention'"
      >
      </fcom-radio-item-group>
    </div>
    <div class="flex flex--row flex--wrap form-subgroup">
      <fcom-radio-item-group
        class="ms-xlarge-b"
        *ngIf="reactiveForm.get('ownWheelchair').enabled"
        [options]="[{ value: 'ownWheelchairYes' }, { value: 'ownWheelchairNo' }]"
        [parentForm]="reactiveForm"
        [controlName]="'ownWheelchair'"
        [isSensitive]="true"
        [isRequired]="true"
        [translationPrefix]="'SERVICE_FORMS.NTServiceForms.fields.ownWheelchair'"
      >
      </fcom-radio-item-group>
    </div>
    <div class="flex flex--row flex--wrap form-subgroup">
      <fcom-radio-item-group
        class="ms-xlarge-b"
        *ngIf="reactiveForm.get('wheelchairType').enabled"
        [options]="wheelchairTypeOptions"
        [parentForm]="reactiveForm"
        [controlName]="'wheelchairType'"
        [isSensitive]="true"
        [isRequired]="true"
        [translationPrefix]="'SERVICE_FORMS.NTServiceForms.fields.wheelchairType'"
      >
      </fcom-radio-item-group>
    </div>
    <div class="flex flex--row flex--wrap form-subgroup">
      <fcom-radio-item-group
        class="ms-xlarge-b"
        *ngIf="reactiveForm.get('wheelchairType').value === 'wheelchairTypeLithiumIon'"
        [options]="[{ value: 'lithiumBattery1' }, { value: 'lithiumBattery2' }]"
        [parentForm]="reactiveForm"
        [controlName]="'lithiumBatteries'"
        [isSensitive]="true"
        [isRequired]="true"
        [translationPrefix]="'SERVICE_FORMS.NTServiceForms.fields.lithiumBatteries'"
      >
      </fcom-radio-item-group>
    </div>

    <div class="flex flex--row flex--wrap form-subgroup">
      <fcom-text-input
        #otherMobilityAidDescription
        data-testid="other-mobility-description"
        *ngIf="reactiveForm.get('otherMobilityAidDescription').enabled"
        [parentForm]="reactiveForm"
        [controlName]="'otherMobilityAidDescription'"
        [isSensitive]="true"
        [type]="TextInputType.TEXTAREA"
        [characterLimit]="textareaLimit100"
        [characterCount]="otherMobilityAidDescription.control?.value?.length || 0"
        [translationPrefix]="'SERVICE_FORMS.NTServiceForms.fields.otherMobilityAidDescription'"
      ></fcom-text-input>
    </div>

    <div class="flex flex--row flex--wrap form-subgroup">
      <fcom-text-input
        *ngIf="
          reactiveForm.get('lithiumBatteries').value === 'lithiumBattery1' ||
          reactiveForm.get('lithiumBatteries').value === 'lithiumBattery2'
        "
        [parentForm]="reactiveForm"
        [controlName]="'lithiumBattery1Power'"
        [isSensitive]="true"
        [translationPrefix]="'SERVICE_FORMS.NTServiceForms.fields.lithiumBattery1Power'"
        [placeHolder]="'SERVICE_FORMS.NTServiceForms.fields.lithiumBattery1Power.placeholder'"
      ></fcom-text-input>
      <fcom-text-input
        *ngIf="reactiveForm.get('lithiumBatteries').value === 'lithiumBattery2'"
        [parentForm]="reactiveForm"
        [controlName]="'lithiumBattery2Power'"
        [isSensitive]="true"
        [translationPrefix]="'SERVICE_FORMS.NTServiceForms.fields.lithiumBattery2Power'"
        [placeHolder]="'SERVICE_FORMS.NTServiceForms.fields.lithiumBattery2Power.placeholder'"
      ></fcom-text-input>
    </div>

    <div class="flex flex--row flex--wrap form-subgroup">
      <span
        *ngIf="reactiveForm.get('wheelchairType').enabled"
        class="font-body-1 ps-small-b nordic-blue-900-text"
        tabindex="0"
        >{{ 'SERVICE_FORMS.NTServiceForms.fields.wheelchairType.note' | finLocalization }}</span
      >
    </div>
    <div class="flex flex--row flex--wrap form-subgroup">
      <fcom-text-input
        *ngIf="reactiveForm.get('wheelchairDepth').enabled"
        [parentForm]="reactiveForm"
        [controlName]="'wheelchairDepth'"
        [isSensitive]="true"
        [translationPrefix]="'SERVICE_FORMS.NTServiceForms.fields.wheelchairDepth'"
      ></fcom-text-input>
      <fcom-text-input
        *ngIf="reactiveForm.get('wheelchairHeight').enabled"
        [parentForm]="reactiveForm"
        [controlName]="'wheelchairHeight'"
        [isSensitive]="true"
        [translationPrefix]="'SERVICE_FORMS.NTServiceForms.fields.wheelchairHeight'"
      ></fcom-text-input>
      <fcom-text-input
        *ngIf="reactiveForm.get('wheelchairWidth').enabled"
        [parentForm]="reactiveForm"
        [controlName]="'wheelchairWidth'"
        [isSensitive]="true"
        [translationPrefix]="'SERVICE_FORMS.NTServiceForms.fields.wheelchairWidth'"
      ></fcom-text-input>
      <fcom-text-input
        *ngIf="reactiveForm.get('wheelchairWeight').enabled"
        [parentForm]="reactiveForm"
        [controlName]="'wheelchairWeight'"
        [isSensitive]="true"
        [translationPrefix]="'SERVICE_FORMS.NTServiceForms.fields.wheelchairWeight'"
      ></fcom-text-input>
      <fcom-text-input
        #reasonForWheelchair
        *ngIf="reactiveForm.get('reasonForWheelchair').enabled"
        [parentForm]="reactiveForm"
        [controlName]="'reasonForWheelchair'"
        [isSensitive]="true"
        [type]="TextInputType.TEXTAREA"
        [characterLimit]="textareaLimit3000"
        [characterCount]="reasonForWheelchair.control?.value?.length || 0"
        [translationPrefix]="'SERVICE_FORMS.NTServiceForms.fields.reasonForWheelchair'"
      ></fcom-text-input>
    </div>
    <div class="flex flex--row flex-wrap form-subgroup">
      <fcom-radio-item-group
        class="ms-xlarge-b"
        *ngIf="reactiveForm.get('ableToSitWithKneesBent').enabled"
        [options]="[{ value: 'ableToSitWithKneesBentYes' }, { value: 'ableToSitWithKneesBentNo' }]"
        [parentForm]="reactiveForm"
        [controlName]="'ableToSitWithKneesBent'"
        [isSensitive]="true"
        [isRequired]="true"
        [translationPrefix]="'SERVICE_FORMS.NTServiceForms.fields.ableToSitWithKneesBent'"
      >
      </fcom-radio-item-group>
    </div>
    <div class="flex flex--row flex--wrap form-subgroup">
      <fcom-radio-item-group
        class="ms-xlarge-b"
        *ngIf="reactiveForm.get('needAssistanceWhere').enabled"
        [options]="[
          { value: 'needAssistanceAtGate' },
          { value: 'needAssistanceAtStairs' },
          { value: 'needAssistanceCarrying' },
        ]"
        [parentForm]="reactiveForm"
        [controlName]="'needAssistanceWhere'"
        [isSensitive]="true"
        [isRequired]="true"
        [translationPrefix]="'SERVICE_FORMS.NTServiceForms.fields.needAssistanceWhere'"
      >
      </fcom-radio-item-group>
    </div>
    <div class="flex flex--row flex--wrap form-subgroup">
      <fcom-radio-item-group
        class="ms-xlarge-b"
        *ngIf="reactiveForm.get('travelingWithAssistant').enabled"
        [options]="[{ value: 'travelingWithAssistantYes' }, { value: 'travelingWithAssistantNo' }]"
        [parentForm]="reactiveForm"
        [controlName]="'travelingWithAssistant'"
        [isSensitive]="true"
        [isRequired]="true"
        [translationPrefix]="'SERVICE_FORMS.NTServiceForms.fields.travelingWithAssistant'"
      >
      </fcom-radio-item-group>
    </div>
    <div class="flex flex--row flex--wrap form-subgroup">
      <fcom-text-input
        *ngIf="
          reactiveForm.get('assistantName').enabled &&
          reactiveForm.get('travelingWithAssistant').value === 'travelingWithAssistantYes'
        "
        [parentForm]="reactiveForm"
        [controlName]="'assistantName'"
        [isSensitive]="true"
        [translationPrefix]="'SERVICE_FORMS.NTServiceForms.fields.assistantName'"
      ></fcom-text-input>
    </div>
    <div class="flex flex--row flex--wrap form-subgroup">
      <fcom-text-input
        #addMedicalEquipment
        *ngIf="reactiveForm.get('addMedicalEquipment').enabled"
        [parentForm]="reactiveForm"
        [controlName]="'addMedicalEquipment'"
        [isSensitive]="true"
        [type]="TextInputType.TEXTAREA"
        [characterLimit]="textareaLimit1000"
        [characterCount]="addMedicalEquipment.control?.value?.length || 0"
        [translationPrefix]="'SERVICE_FORMS.NTServiceForms.fields.addMedicalEquipment'"
      ></fcom-text-input>
    </div>
    <div class="flex flex--row flex--wrap form-subgroup">
      <fcom-radio-item-group
        class="ms-xlarge-b"
        *ngIf="reactiveForm.get('medicalCondition').enabled"
        [options]="medicalConditionOptions"
        [parentForm]="reactiveForm"
        [controlName]="'medicalCondition'"
        [isSensitive]="true"
        [isRequired]="true"
        [translationPrefix]="'SERVICE_FORMS.NTServiceForms.fields.medicalCondition'"
      >
      </fcom-radio-item-group>
      <fcom-radio-item-group
        class="ms-xlarge-b"
        *ngIf="reactiveForm.get('medicalEquipment').enabled"
        [options]="[
          { value: 'CAPAPDevice' },
          { value: 'portableOxygenConcentrator' },
          { value: 'otherMedicalEquipment' },
        ]"
        [parentForm]="reactiveForm"
        [controlName]="'medicalEquipment'"
        [isSensitive]="true"
        [isRequired]="true"
        [translationPrefix]="'SERVICE_FORMS.NTServiceForms.fields.medicalEquipment'"
      >
      </fcom-radio-item-group>
      <span
        *ngIf="reactiveForm.get('portableOxygenConcentratorModel').enabled"
        class="font-body-1 mr-medium-b nordic-blue-900-text"
        tabindex="0"
        >{{ 'SERVICE_FORMS.NTServiceForms.fields.portableOxygenConcentratorModel.note' | finLocalization }}</span
      >
    </div>
    <div class="flex flex--row flex--wrap form-subgroup">
      <fcom-text-input
        *ngIf="reactiveForm.get('CAPAPDeviceModel').enabled"
        [parentForm]="reactiveForm"
        [controlName]="'CAPAPDeviceModel'"
        [isSensitive]="true"
        [translationPrefix]="'SERVICE_FORMS.NTServiceForms.fields.CAPAPDeviceModel'"
      ></fcom-text-input>
      <fcom-text-input
        *ngIf="reactiveForm.get('portableOxygenConcentratorModel').enabled"
        [parentForm]="reactiveForm"
        [controlName]="'portableOxygenConcentratorModel'"
        [isSensitive]="true"
        [translationPrefix]="'SERVICE_FORMS.NTServiceForms.fields.portableOxygenConcentratorModel'"
      ></fcom-text-input>
      <fcom-text-input
        *ngIf="reactiveForm.get('otherMedicalEquipmentType').enabled"
        [parentForm]="reactiveForm"
        [controlName]="'otherMedicalEquipmentType'"
        [isSensitive]="true"
        [translationPrefix]="'SERVICE_FORMS.NTServiceForms.fields.otherMedicalEquipmentType'"
      ></fcom-text-input>
      <fcom-text-input
        *ngIf="reactiveForm.get('otherMedicalEquipmentModel').enabled"
        [parentForm]="reactiveForm"
        [controlName]="'otherMedicalEquipmentModel'"
        [isSensitive]="true"
        [translationPrefix]="'SERVICE_FORMS.NTServiceForms.fields.otherMedicalEquipmentModel'"
      ></fcom-text-input>
    </div>
    <div class="flex flex--row flex--wrap form-subgroup">
      <fcom-radio-item-group
        class="ms-xlarge-b"
        *ngIf="reactiveForm.get('otherReasonForAssistance').enabled"
        [options]="otherReasonForAssistanceOptions"
        [parentForm]="reactiveForm"
        [controlName]="'otherReasonForAssistance'"
        [isSensitive]="true"
        [isRequired]="true"
        [translationPrefix]="'SERVICE_FORMS.NTServiceForms.fields.otherReasonForAssistance'"
      >
      </fcom-radio-item-group>
    </div>
    <div class="flex flex--row flex--wrap form-subgroup">
      <fcom-text-input
        #additionalInformation
        data-testid="additional-information"
        *ngIf="reactiveForm.get('additionalInformation').enabled"
        [parentForm]="reactiveForm"
        [controlName]="'additionalInformation'"
        [isSensitive]="true"
        [type]="TextInputType.TEXTAREA"
        [characterLimit]="textareaLimit1000"
        [characterCount]="additionalInformation.control?.value?.length || 0"
        [translationPrefix]="'SERVICE_FORMS.NTServiceForms.fields.additionalInformation'"
      ></fcom-text-input>
    </div>
    <div class="flex flex--row flex--wrap form-subgroup">
      <fcom-file-uploader
        class="block flex--basis-full full-width form-subgroup"
        [class]="attachments.length ? 'mr-large-b' : 'mr-xlarge-b'"
        [controlName]="SpecialAssistanceFormFields.MEDA_ATTACHMENT"
        [i18n]="'SERVICE_FORMS.NTServiceForms.fields.fileUploader' | finLocalization"
        [maxAttachments]="maxAttachments"
        [maxSizeInBytes]="maxSizeInBytes"
        [parentForm]="reactiveForm"
        [uploadService]="uploadFile()"
        #fileUploader
      ></fcom-file-uploader>
    </div>
    <div class="flex flex--row flex--wrap">
      <fcom-button
        [disabled]="formDisabled"
        [type]="ButtonType.SUBMIT"
        [text]="'SERVICE_FORMS.NTServiceForms.submit' | finLocalization"
      ></fcom-button>
    </div>
  </form>
  <!-- While sending -->
  <div *ngIf="isLoading" class="relative loader align-center">
    <p>{{ 'SERVICE_FORMS.NTServiceForms.loading.title' | finLocalization }}</p>
    <fin-loader [type]="LoaderType.INLINE"></fin-loader>
  </div>
  <!-- Success view -->
  <div *ngIf="formStatus === FormStatus.COMPLETE" class="success-message">
    <h2>{{ 'SERVICE_FORMS.NTServiceForms.success.title' | finLocalization }}</h2>
    <p
      *ngIf="completedServiceRequestNumber"
      [innerHTML]="
        'SERVICE_FORMS.NTServiceForms.success.message'
          | finLocalization: { caseReferenceNumber: completedServiceRequestNumber }
      "
    ></p>
    <p
      *ngIf="duplicateServiceRequestNumber"
      [innerHTML]="
        'SERVICE_FORMS.NTServiceForms.success.duplicateServiceRequestNumber'
          | finLocalization: { caseReferenceNumber: duplicateServiceRequestNumber }
      "
    ></p>
  </div>
</div>
